// SlicePlugin definition for the person slice (PRD-F2 §TR3, §T22b).
//
// Migrated to the discriminated-union CapabilityDescriptor form (PRD-X §TR3).
// Mirrors the checkbox slice's capability set: 7 descriptors including
// 'plain-edit' for the name inline-editor. Omits 'resize' (OQ2 resolved by
// Pre-Grep T0: person has no Konva.Transformer wiring today) and 'rich-edit'
// (the name is a single-line plain-text label). isAnchorTarget always
// returns true per ND2.

import type { SlicePlugin } from '../../core/object-registry.js';
import {
  type CapabilityDescriptor,
  TEXT_CONTENT_VIEW,
  PLAIN_EDIT,
  ANCHOR_TARGET_VIEW,
  BG_COLOR_VIEW,
  BG_COLOR_EDIT,
  STACK_PRESENCE_VIEW,
  UPDATABLE_PROPERTIES_EDIT,
  ROTATION_EDIT,
} from '../../core/capabilities/capability.interface.js';
import type { PersonObject } from './person.interface.js';
import { createPersonDefaults } from './person-defaults.factory.js';
import { createNode, updateNode, personAnchorBounds } from './person.renderer.js';

const PERSON_CAPABILITIES: readonly CapabilityDescriptor[] = [
  { capability: 'text-content', view: TEXT_CONTENT_VIEW },
  { capability: 'plain-edit', edit: PLAIN_EDIT },
  { capability: 'anchor-target', view: ANCHOR_TARGET_VIEW },
  { capability: 'background-color', view: BG_COLOR_VIEW, edit: BG_COLOR_EDIT },
  { capability: 'stack-presence', view: STACK_PRESENCE_VIEW },
  { capability: 'updatable-properties', edit: UPDATABLE_PROPERTIES_EDIT },
  { capability: 'rotation', edit: ROTATION_EDIT },
];

export const personSlice: SlicePlugin<PersonObject> = {
  type: 'person',
  role: 'primary',
  capabilities: PERSON_CAPABILITIES,
  display: {
    iconUrl: 'fa-user',
    label: 'Person',
  },
  createDefaults: createPersonDefaults,
  createNode,
  updateNode,
  isAnchorTarget: () => true,
  // Lines dock to the visible avatar+name box, not the padded object box.
  anchorBounds: personAnchorBounds,
};
